import script from "./AdminPodcastGeneratedVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPodcastGeneratedVideos.vue?vue&type=script&setup=true&lang=js"

import "./AdminPodcastGeneratedVideos.vue?vue&type=style&index=0&id=24854f70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24854f70"]])

export default __exports__